// extracted by mini-css-extract-plugin
export var column = "CaseStudiesGrid-module--column--64cd2";
export var first = "CaseStudiesGrid-module--first--d345e";
export var grid = "CaseStudiesGrid-module--grid--100e6";
export var third = "CaseStudiesGrid-module--third--0c3df";